import cz from './translate-cz.json';
import en from './translate-en.json';

export default function Translator() {
  const resources = { cz, en };
  const supportedLangs = Object.keys(resources);

  const storedLang = localStorage.getItem("lang");
  const lang = supportedLangs.includes(storedLang) ? storedLang : "cz";
  const translates = resources[lang];

  const translate = (text) => {
    const key = text.toLowerCase();
    return translates[key] || text;
  };

  return translate;
}
